module.exports = __webpack_public_path__ + "img/Logical-Framework.ff2a7105.png";